import { useContent } from "../../context/ContentContext";
import { Reveal } from "./Reveal";
import { SectionBg } from "./SectionBg";

export const Mission = () => {
  const { content } = useContent();
  const m = content.mission;
  return (
    <section id="mission" className="relative overflow-hidden bg-surface py-24 md:py-40 border-b border-white/10" data-testid="mission-section">
      <SectionBg id="mission" />
      <div className="relative z-10 max-w-[1500px] mx-auto px-6 md:px-12">
        <Reveal className="max-w-4xl mb-16 md:mb-24">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-10 bg-electric" />
            <span className="text-xs tracking-[0.35em] uppercase text-electric">{m.eyebrow}</span>
          </div>
          <h2 className="font-serif text-4xl md:text-6xl text-white tracking-tight leading-[1.05]">{m.heading}</h2>
          <p className="mt-8 text-base md:text-lg text-secondary2 font-light leading-relaxed max-w-2xl">{m.body}</p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {m.pillars.map((p, i) => (
            <Reveal key={i} delay={i * 0.12} className="h-full">
              <div data-testid={`mission-pillar-${i}`}
                className="group relative h-full rounded-xl border border-white/10 bg-gradient-to-b from-[#111111] to-[#0a0a0a] p-8 md:p-10 shadow-[0_10px_30px_-18px_rgba(0,0,0,0.9)] transition-[transform,border-color,box-shadow] duration-500 hover:-translate-y-1.5 hover:border-electric/40 hover:shadow-[0_28px_70px_-24px_rgba(0,0,0,0.95)]">
                <span className="pointer-events-none absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-electric/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <h3 className="font-serif text-3xl md:text-4xl text-white mb-4">{p.title}</h3>
                <p className="text-sm text-secondary2 font-light leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
